const ApplyFilter = ({ onClearFilter, onApplyFilter, customCss = "" }) => {
  return (
    <div className="apply_filter_container">
      <button
        className={`apply_filter_btn ${customCss}`}
        onClick={onApplyFilter}
      >
        Apply Filter
      </button>
      <button
        className={`clear_filter clear-filter-plain-button ${customCss}`}
        onClick={onClearFilter}
      >
        Clear Filter
      </button>
    </div>
  );
};

export default ApplyFilter;
